import { Injectable, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnAppInit } from '@frontend/vanilla/core';

import { CompetitionHeaderWidgetComponent } from '../competition-header-widget.component';
import { CompetitionTeamsWidgetComponent } from '../competition-teams-widget.component';

@Injectable({ providedIn: 'root' })
export class WidgetRegistrationService implements OnAppInit {
    private widgetRegistry = inject(WidgetRegistryService);

    onAppInit(): void {
        this.widgetRegistry.register(WidgetType.CompetitionHeader, CompetitionHeaderWidgetComponent);
        this.widgetRegistry.register(WidgetType.CompetitionTeams, CompetitionTeamsWidgetComponent);
    }
}
